import { Spin } from "antd";
import React from "react";
import "./Loader.scss";

export function PairedRevolution({ size = "lg", className = "" }) {
  const validSizes = ["sm", "md", "lg", "xl"];
  const selectedSize = validSizes.includes(size) ? size : "md";
  return (
    <div
      className={`paired-revolution paired-revolution--${selectedSize} ${className}`}
      role="status"
      aria-label="Loading"
    >
      <div className="paired-revolution__center" />
      <div className="paired-revolution__orbit">
        <div className="paired-revolution__dot paired-revolution__dot--first" />
        <div className="paired-revolution__dot paired-revolution__dot--second" />
      </div>
    </div>
  );
}

const Loader = ({ showSpin = true }) => (
  <div
    className="loaderWrapper"
    style={{
      backgroundColor: showSpin ? "transparent" : "rgba(0, 0, 0, 0.1)",
    }}
  >
    <div className="spinnerBox">
      {/* <i className="fa fa-spinner fa-spin" />      
      <div>{showSpin ? <Spin /> : "Loading ..."}</div> */}
      <PairedRevolution size="lg" />
    </div>
  </div>
);

export default Loader;
